"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const ArrowDown_1 = __importDefault(require("@kyruus/react-ikons/ArrowDown"));
const styles_1 = require("./styles");
const Accordion = (_a) => {
    var { id, mode = 'single', headerText, initialExpanded = false, offsetTop = 0, onExpand, onCollapse, children } = _a, props = __rest(_a, ["id", "mode", "headerText", "initialExpanded", "offsetTop", "onExpand", "onCollapse", "children"]);
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(initialExpanded);
    const accordionContentRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (!isExpanded) {
            (_a = accordionContentRef.current) === null || _a === void 0 ? void 0 : _a.setAttribute('inert', '');
        }
        else {
            (_b = accordionContentRef.current) === null || _b === void 0 ? void 0 : _b.removeAttribute('inert');
        }
    }, [isExpanded]);
    return (react_1.default.createElement(styles_1.StyledAccordion, Object.assign({ expanded: isExpanded, onChange: () => {
            setIsExpanded((prev) => !prev);
            if (isExpanded) {
                if (onCollapse)
                    onCollapse();
            }
            else {
                if (onExpand)
                    onExpand();
            }
        }, offsetTop: offsetTop }, props),
        react_1.default.createElement(material_1.AccordionSummary, { id: `${id}-header`, "data-testid": `${id}-header`, expandIcon: react_1.default.createElement(ArrowDown_1.default, null), "aria-controls": id }, headerText),
        react_1.default.createElement(material_1.AccordionDetails, { "data-testid": `${id}-content`, ref: accordionContentRef }, mode === 'single' ? (react_1.default.createElement(styles_1.StyledContainer, { "data-testid": `${id}-content-child` }, react_1.default.Children.map(children, (child) => (0, react_1.isValidElement)(child)
            ? react_1.default.cloneElement(child, { isExpanded })
            : null))) : (react_1.default.Children.map(children, (child) => {
            if ((0, react_1.isValidElement)(child)) {
                return (react_1.default.createElement(styles_1.StyledContainer, { "data-testid": `${id}-content-child` }, react_1.default.cloneElement(child, { isExpanded })));
            }
            return null;
        })))));
};
exports.Accordion = Accordion;
//# sourceMappingURL=Accordion.js.map